import React from 'react';
import { ImageFullWidth } from '../../components';

const HeroImageStyle = {
  img: {
    height: (theme) => [
      `calc(100vh - ${theme.stylesConfig.hearderHeightMobile + parseInt(theme.stylesConfig.containerSpaceMobile) + 'px'})`,
      null,
      `calc(100vh - ${theme.stylesConfig.hearderHeightDesktop + parseInt(theme.stylesConfig.containerSpaceDesktop) + 'px'})`,
    ],
  },
};

const HeroImage = ({ src, alt }) => {
  return <ImageFullWidth style={HeroImageStyle.img} src={src} alt={alt} />;
};

export default HeroImage;
